'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Establishment = require('./Establishment');

var _Establishment2 = _interopRequireDefault(_Establishment);

var _Partners = require('./Partners');

var _Partners2 = _interopRequireDefault(_Partners);

var _api = require('./api');

var _config = require('./config');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'hundredrooms',
  version: _constants.VERSION,
  establishment: _Establishment2.default,
  search: _Establishment2.default.search,
  partners: _Partners2.default,
  api: { getReverseGeoRequest: _api.getReverseGeoRequest },
  setConfig: _config.setConfig,
  getConfig: _config.getConfig,
  ORDERING: _constants.ORDERING,
  CANCELLATION_POLICY: _constants.CANCELLATION_POLICY,
  RANKING_LOW_LIMIT: _constants.RANKING_LOW_LIMIT
};